var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M58.5,30.3H19.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h38.9c0.8,0,1.5,0.7,1.5,1.5S59.3,30.3,58.5,30.3z","key":0}),React.createElement("path",{"d":"M28.9 39.8c-.4 0-.8-.2-1.1-.4l-9.3-9.5c-.6-.6-.6-1.5 0-2.1l9.3-9.5c.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1l-8.2 8.5 8.2 8.5c.6.6.6 1.5 0 2.1a1.69 1.69 0 0 1-1 .3zm.8 20.2c-2.1 0-4.3-.2-6.5-.7C9.8 56.3.3 44.5 0 30.6S8.9 4.5 22.2 1s27.1 2.6 33.6 14.9c.4.7.1 1.6-.6 2s-1.6.1-2-.6C47.3 6.2 34.9.7 22.9 3.9 10.9 7 2.7 18 3 30.5c.2 12.5 8.8 23.2 20.9 25.9s24.3-3.3 29.7-14.6c.4-.7 1.2-1.1 2-.7a1.59 1.59 0 0 1 .7 2C51.2 53.6 40.8 60 29.7 60z","key":1})]);
}

Logout.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Logout;

Logout.default = Logout;
